import Accordion from "../../components/Accordianitem/Accordion";
import DiagnosisForm from "./AssessmentContents/Diagnosis";
import ImmunizationTable from "./AssessmentContents/Immunization";
import StrokeScaleForm from "./AssessmentContents/Nhsstroke/Nhsstroke";
import PhysicalExamination from "./AssessmentContents/Physical Examination/PhysicalExamination";
import VisionScaleForm from "./AssessmentContents/Vision";
import { Sparkles } from "lucide-react";

interface SubjectiveContentProps {
  id: string;
}

const AssessmentContent: React.FC<SubjectiveContentProps> = ({ id }) => {
  const accordionItems = [
    { title: <span className='font-jost text-lg'>Diagnosis (Including ICD)</span>, content: <DiagnosisForm patientId={id} /> },
    { title: <span className='font-jost text-lg'>Immunization Status</span>, content: <ImmunizationTable patientId={id} /> },
    { title: <span className='font-jost text-lg'>NIHSS Stroke</span>, content: <StrokeScaleForm patientId={id}/> },
    { title: <span className='font-jost text-lg'>Vision</span>, content: <VisionScaleForm patientId={id} /> },
    { title: <span className='font-jost text-lg'>Physical Examination</span>, content: <PhysicalExamination patientId={id} /> },
  ];

  return (
    <div className="p-4 space-y-6">
      <Accordion items={accordionItems} />
    </div>
  );
};

export default AssessmentContent;
